export const LOCAL_STORAGE_KEY_BOARD_IDS_OPENED_DESCRIPTION = 'boardIdsOpenedDescription';
